import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLoginPage() {
  const { login, admin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (admin) navigate("/admin");
  }, [admin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f7f4f1] px-4" data-testid="admin-login-page">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-3xl border border-neutral-200 bg-white p-8"
      >
        <p className="text-[11px] uppercase tracking-[0.3em] text-neutral-500">
          Lash Dollz Vk Beauty
        </p>
        <h1 className="mt-1 text-xl font-medium text-neutral-900">Admin login</h1>
        <div className="mt-6 space-y-4 text-sm">
          <div>
            <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="h-10 w-full rounded-full border border-neutral-300 px-4 outline-none focus:border-neutral-900"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium uppercase tracking-[0.2em] text-neutral-700">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="h-10 w-full rounded-full border border-neutral-300 px-4 outline-none focus:border-neutral-900"
            />
          </div>
          {error && (
            <p className="text-xs text-red-600" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="h-10 w-full rounded-full bg-black text-[11px] font-medium uppercase tracking-[0.25em] text-white hover:bg-neutral-800 disabled:bg-neutral-300"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
